import { mua } from "./api";

/**
 * ดึง JWT สำหรับผู้สมัคร (ใช้เปิดหน้าพิมพ์ที่บังคับ auth)
 * เรียกเมื่อมีเลขบัตร แต่ยังไม่มี token
 * @param {string} [citizentOverride] เลขบัตรจากข้อมูลหน้า (เช่น CITIZENT_LOGIN)
 */
export async function ensureApplicantToken(citizentOverride) {
  try {
    const existing = localStorage.getItem("token");
    if (existing) return existing;

    const citizent =
      (citizentOverride && String(citizentOverride).trim()) ||
      localStorage.getItem("citizent") ||
      "";
    if (!citizent) return "";

    localStorage.setItem("citizent", citizent);

    const res = await fetch(
      `${mua}/admissionnew2022/showcheckmember/${encodeURIComponent(citizent)}`
    );
    if (!res.ok) return "";
    const json = await res.json();
    const auth = json?.data?.auth || json?.auth || "";
    if (auth) {
      localStorage.setItem("token", auth);
    }
    return auth || "";
  } catch {
    return "";
  }
}
